import React, { useState, useEffect } from 'react'
import { Message, Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import pathname from '../../../constants/pathname'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import { CANCEL, DEFAULT_ERR_MSG, SAVE, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { doneLoading, startLoading } from '../../../utils/loading'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { saveSettingFormTargetGroup } from '../../../redux/actions/subProjectFormSetting'
import notification from '../../../utils/notification'
import SettingEditFormListWidget from '../dynamicForm/SettingEditFormListWidget'
import { createDynamicListReq } from '../../../utils/dynamicListReq'
import { TEMP_FORM_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'

export default function ProjectTagetSettingWidget(props) {
  // const { showCommandButton, isEdit, onChangeIsEdit, isSubProject } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [notiMsg, setNotiMsg] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isRefash, setIsRefash] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)

  const formId = sessionGetItemStr(TEMP_FORM_ID)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveSettingFormTargetGroup(formId, request)
      if (response) {
        setFormSchema(response)
        setNotiMsg({
          type: 'success',
          msg: SAVE_SUCCESS_MSG,
        })
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 2500,
        })
        onRefash()
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      } else {
        setNotiMsg({
          type: 'error',
          msg: DEFAULT_ERR_MSG,
        })
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error', e)
      setNotiMsg({
        type: 'error',
        msg: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
      })
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    doneLoading()
    setIsLoading(false)

    setTimeout(() => {
      setNotiMsg('')
    }, 2500)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = createDynamicListReq(data.newObjects, data.newObjectsValuesName)

    let request = {
      id: formSchema.id,
      values: values,
      descValues: data.descSettingValues || [],
      descDelIds: data.descDelIds || [],
    }
    console.log('request : ', JSON.stringify(request))

    handleSave(request)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {!isRefash && (
        <SettingEditFormListWidget
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          setLoading={setIsLoading}
        />
      )}

      <hr />
      {notiMsg && (
        <Message
          closable
          showIcon
          type={notiMsg.type}
          description={notiMsg.msg}
          onClose={() => setNotiMsg('')}
          style={{ marginBottom: 10 }}
        />
      )}
      <div className="right">
        <ViewButton
          style={{
            marginRight: 10,
            marginBottom: 10,
          }}
          onClick={() => {
            window.open(`${pathname.subProjectNew.proposal.targetOperationArea}?preView`, '_blank')
          }}
          children={'แสดงตัวอย่าง'}
        />
        <SaveButton
          children={SAVE + formSchema.buttonText || ''}
          disabled={isLoading}
          onClick={handleSubmit(onSubmit)}
        />
        <CancelButton children={CANCEL} onClick={onRefash} />
      </div>

      {isLoading && <OverlayLoader />}
    </Panel>
  )
}
